import React from 'react';
import ArrowRight from 'iconsax-react/dist/esm/ArrowRight';
import Call from 'iconsax-react/dist/esm/Call';
import Sms from 'iconsax-react/dist/esm/Sms';
import Profile2User from 'iconsax-react/dist/esm/Profile2User';
import MagicStar from 'iconsax-react/dist/esm/MagicStar';
import { cn } from '../../lib/utils';
import { TABLE_CARD_SIZE_CLASS } from '../inventory-carousel/tableCardLayout';

export type NoticeTileIcon = 'phone' | 'email' | 'cross-sell' | 'event';

const BACKDROP: Record<NoticeTileIcon, { Glyph: typeof Call; variant: 'Linear' | 'Bold' }> = {
	phone: { Glyph: Call, variant: 'Linear' },
	email: { Glyph: Sms, variant: 'Bold' },
	'cross-sell': { Glyph: Profile2User, variant: 'Bold' },
	event: { Glyph: MagicStar, variant: 'Bold' }
};

export interface NoticeTileProps {
	icon: NoticeTileIcon;
	title: string;
	subtitle: string;
	href: string;
	external?: boolean;
	onClick?: () => void;
	'data-cy'?: string;
}

export const NoticeTile = ({ icon, title, subtitle, href, external, onClick, 'data-cy': dataCy }: NoticeTileProps) => {
	const { Glyph, variant } = BACKDROP[icon];
	const externalProps = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};

	return (
		<a
			href={href}
			onClick={onClick}
			data-cy={dataCy}
			{...externalProps}
			className={cn(
				TABLE_CARD_SIZE_CLASS,
				'group relative flex items-center overflow-hidden rounded-[20px] border border-tablz-med-gray-4 bg-tablz-med-gray-3 p-1',
				'shadow-[0px_1px_2px_#0000000D] transition-colors hover:bg-tablz-med-gray-6'
			)}
		>
			<span
				aria-hidden
				className="pointer-events-none absolute right-[-40px] top-1/2 -translate-y-1/2 rotate-180 -scale-y-100 opacity-10"
			>
				<Glyph size={280} color="#FFFFFF" variant={variant} />
			</span>
			<div className="relative z-[1] flex w-full items-center justify-between gap-3 px-5 py-4">
				<div className="flex min-w-0 flex-col gap-1.5">
					<p className="truncate font-lora text-[20px] font-medium leading-none text-white">{title}</p>
					<p className="whitespace-pre-line font-poppins text-sm leading-[1.4] text-white/50">{subtitle}</p>
				</div>
				<ArrowRight
					size={32}
					color="#FFFFFF"
					variant="Linear"
					className="shrink-0 transition-transform group-hover:translate-x-0.5"
				/>
			</div>
		</a>
	);
};
